<div class="caller-info row" [style.display]="stateValue === 'inactive' ? 'none' : ''">
   <!--  Calling information-->
   <div>
      <ng-content></ng-content>
   </div>
</div>

<div class="dial-control-row" fxLayout="row">
   <button
      class="dial-control dial-control-left"
      fxFlex="1 1 auto"
      kendoButton
      [disabled]="leftIconDisabled"
      (click)="onLeftButtonClick()"
   >
      <div [ngClass]="{ 'sam-wiggle': samWiggle }">
         <fa-icon [icon]="leftIcon" size="2x"></fa-icon>
      </div>
   </button>
   <button
      class="dial-control dial-control-right"
      fxFlex="1 1 auto"
      kendoButton
      [disabled]="rightIconDisabled"
      (click)="onRightButtonClick()"
   >
      <div>
         <fa-icon [icon]="rightIcon" size="2x"></fa-icon>
      </div>
   </button>
</div>

<div *ngIf="progressBar">
   <div [style.width]="width + '%'"></div>
</div>
